import { gql } from "@apollo/client"

const DATE_TIME_JOB_STEP_FIELDS = gql`
  fragment DateTimeJobStepFields on DateTimeJobStep {
    id
    step
    number
    section
    name
    description
    responseType
    responseMandatory
    response
    skip
    notApplicable
    unresolvedActions
    hasResolvedActions
    completed @client
    completedAt
    completedBy {
      ...JobStepCompletedByFields
    }
    uploads {
      ...JobStepUploadsFields
    }
    notes {
      ...JobStepNotesFields
    }
    repeatable
  }
`

export { DATE_TIME_JOB_STEP_FIELDS }
